import Lookup from '../components/forms/Lookup'

const Index = () => <Lookup />
Index.displayName = 'Universal Admin Portal';
Index.getLayout = () => <Lookup />

export default Index
